import React from "react";
import classnames from "classnames";

import Container from "@/components/Container";
import { GridColumns } from "@/components/Container/Container.interface";
import Typography, { Variant } from "@/components/Typography";
import { ClassName } from "@/helpers/pageHelpers/Common/interface";

import styles from "./ListHeader.module.scss";

export const ListHeader: React.FC<{
  title: string;
  count?: number | string;
  component?: Variant;
  className?: ClassName;
  children?: any;
}> = ({ title, count, component = "h3", className, children }) => (
  <div className={classnames(styles.top, className)}>
    <Container grid={GridColumns.Three}>
      <Typography
        variant="hero"
        component={component}
        className={styles.heading}
      >
        <span>{title}</span>

        {count && (
          <Typography variant="h3" className={styles.count}>
            {count}
          </Typography>
        )}
      </Typography>

      {children}
    </Container>
  </div>
);

export default ListHeader;
